import type { AdminAuthUser } from '../types/auth';
import type {
  LoginCredentials,
  LoginResponse,
  SessionResponse,
} from '../types/auth';

const API_URL = import.meta.env.VITE_API_URL;

if (!API_URL) {
  throw new Error('VITE_API_URL environment variable is not defined.');
}

export async function login(
  credentials: LoginCredentials,
): Promise<LoginResponse> {
  const response = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(credentials),
  });

  const body = await response.json();

  if (!response.ok) {
    throw new Error(body.message ?? `Login failed: ${response.status}`);
  }

  return body as LoginResponse;
}

export async function getSession(): Promise<SessionResponse | null> {
  const response = await fetch(`${API_URL}/api/admin/session`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  });

  if (response.status === 401 || response.status === 403) {
    return null;
  }

  if (!response.ok) {
    throw new Error(
      `Failed to check authentication session: ${response.status}`,
    );
  }
  return response.json() as Promise<SessionResponse>;
}

export async function logout(): Promise<void> {
  const response = await fetch(`${API_URL}/api/auth/logout`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to log out: ${response.status}`);
  }
}
